import React from 'react';
import { Box, Typography, Button, IconButton } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

const VendorInvoiceHeader = ({ invoiceNumber, onBack }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        mb: 3,
        pb: 2,
        borderBottom: '1px solid #E8E9E9',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <IconButton
          onClick={onBack}
          disableRipple
          sx={{
            backgroundColor: '#FFF',
            width: 40,
            height: 40,
            borderRadius: '8px',
            boxShadow: '0 0 30px 2px rgba(0, 0, 0, 0.05)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            '&:hover': {
              backgroundColor: '#f5f5f5',
            },
          }}
        >
          <ArrowBackIosIcon sx={{ ml: '2px', fontSize: '16px' }} />
        </IconButton>
        <Typography
          sx={{
            fontSize: '24px',
            fontFamily: 'Inter',
            fontWeight: 700,
            color: 'black',
          }}
        >
          Invoice {invoiceNumber}
        </Typography>
      </Box>
    </Box>
  );
};

export default VendorInvoiceHeader;
